import React from 'react';
import { CheckCircle, X } from 'lucide-react';

const SuccessMessage = ({
  message,
  onDismiss,
  className = '',
  ...props
}) => {
  if (!message) return null;

  return (
    <div className={`bg-green-50 border border-green-200 rounded-md p-4 ${className}`} {...props}>
      <div className="flex">
        <CheckCircle size={20} className="text-green-400 flex-shrink-0 mt-0.5" />
        <div className="ml-3 flex-1">
          <p className="text-sm text-green-700">{message}</p>
        </div>
        {onDismiss && (
          <button
            onClick={onDismiss}
            className="ml-auto flex-shrink-0 text-green-400 hover:text-green-600 focus:outline-none focus:ring-2 focus:ring-green-500 rounded-md p-1"
          >
            <X size={16} />
          </button>
        )}
      </div>
    </div>
  );
};

export default SuccessMessage;